import {useAddWithPDF} from 'components/hooks/useAdd';
import {AddingOptions} from 'components/grid-dx/types';
import {collaborator} from 'constants/url';

function useAddCollaborator() {
  const addCollabo = useAddWithPDF(collaborator);
  return (addingOptions: AddingOptions) => addCollabo(addingOptions);
}

export default useAddCollaborator;
